module.exports = __webpack_public_path__ + "img/bg_aviodPhoney_04.c34775d8.jpg";